import * as React from 'react';
import { css } from '@emotion/core';
import { TABLE_COLORS, COLORS } from '../globalStyle/colors';
import { ReportRecipientParticipant } from './models';
import Card from '../layout/card/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import LocalDiv from '../localization/LocalDiv';
import { FLEX_ROW, FLEX_COLUMN } from '../layout/flexBox';
import Spacer from '../layout/Spacer';
import { useMsgText } from '../localization/hooks';
import { Str } from '../localization/translationKeys';


const styles = {
  root:    css`
    background-color: ${TABLE_COLORS.DARK_BG};
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    max-width: 260px;
    background-color: ${COLORS.BLUE};
    align-items: flex-start;
  `,
  text: css`
    max-width: 240px;
    color: ${COLORS.WHITE};
  `,
  closeButton: css`
    border-radius: 0;
    border-width: 0;
    color: ${COLORS.WHITE};
    font-size: 16px;
    background-color: transparent;
    align-self: flex-start;
    justify-self: flex-end;
    padding: 0;
    
    &:hover {
      color: ${COLORS.LIGHT_GREY};
      cursor: pointer;
    }
  `,
};

type Props = {
  participant: ReportRecipientParticipant;
  onDelete: (participant: ReportRecipientParticipant) => void;
  className?: string;
};

/**
 * ProjectCard: a component that renders a recipient participant.
 * Mostly used on mobile.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const RecipientParticipantCard: React.FC<Props> = props => {
  const closeLabel = useMsgText(Str.Close);

  return (
    <Card css={[FLEX_ROW, styles.root]} className={props.className}>
      <LocalDiv css={[FLEX_COLUMN, styles.text]}>
        {props.participant.displayName}
      </LocalDiv>
      <Spacer sizePx={5} />
      <button
        aria-label={closeLabel}
        onClick={() => props.onDelete(props.participant)}
        css={[FLEX_COLUMN, styles.closeButton]}
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </Card>
  );
};

export default RecipientParticipantCard;
